var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isAllowed
    ? _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$ct("import-products"))),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-content",
            [_c("app-missing-module", { attrs: { "module-id": "12" } })],
            1
          ),
        ],
        1
      )
    : _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("import-products")))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      !_vm.file
                        ? _c("app-file-upload", {
                            attrs: {
                              sending: _vm.uploading,
                              label: _vm.$ct("drop-here-csv"),
                              "allowed-extensions": _vm.allowedExtensions,
                              "max-size": 1e8,
                            },
                            on: {
                              input: function ($event) {
                                _vm.file = $event
                              },
                            },
                          })
                        : _c(
                            "p",
                            [
                              _vm._v(" " + _vm._s(_vm.file.name) + " "),
                              _c(
                                "w-button",
                                {
                                  staticClass: "danger",
                                  attrs: { flat: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.file = null
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "times" } })],
                                1
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct(
                            "csv-import-product-matching-method-label"
                          ),
                          items: _vm.productMatchingMethods,
                        },
                        model: {
                          value: _vm.productMatchingMethod,
                          callback: function ($$v) {
                            _vm.productMatchingMethod = $$v
                          },
                          expression: "productMatchingMethod",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$ct(
                              "csv-import-existing-product-handling-label"
                            )
                          )
                        ),
                      ]),
                      _vm._l(_vm.existingProductHandlingItems, function (item) {
                        return _c("w-radio", {
                          key: item.value,
                          attrs: {
                            checked: _vm.existingProductHandling == item.value,
                            label: item.text,
                            disabled: item.disabled,
                          },
                          on: {
                            input: function ($event) {
                              _vm.existingProductHandling = item.value
                            },
                          },
                        })
                      }),
                    ],
                    2
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$ct(
                              "csv-import-existing-barcode-handling-label"
                            )
                          )
                        ),
                      ]),
                      _vm._l(_vm.existingBarcodeHandlingItems, function (item) {
                        return _c("w-radio", {
                          key: item.value,
                          attrs: {
                            checked: _vm.existingBarcodeHandling == item.value,
                            label: item.text,
                            disabled: item.disabled,
                          },
                          on: {
                            input: function ($event) {
                              _vm.existingBarcodeHandling = item.value
                            },
                          },
                        })
                      }),
                    ],
                    2
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("csv-import-create-new-product"),
                        },
                        model: {
                          value: _vm.createNewProducts,
                          callback: function ($$v) {
                            _vm.createNewProducts = $$v
                          },
                          expression: "createNewProducts",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-radio", {
                        attrs: {
                          label: _vm.$ct("use-comma-decimal-seperator"),
                          checked: _vm.useCommaSeperator,
                        },
                        on: {
                          input: function ($event) {
                            _vm.useCommaSeperator = true
                          },
                        },
                      }),
                      _c("w-radio", {
                        attrs: {
                          label: _vm.$ct("use-dot-decimal-seperator"),
                          checked: !_vm.useCommaSeperator,
                        },
                        on: {
                          input: function ($event) {
                            _vm.useCommaSeperator = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban", disabled: _vm.uploading },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: {
                    disabled: _vm.file == null || _vm.uploading,
                    icon: "check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.upload()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("start-import")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }